"use client"

import Link from "next/link"
import { useEffect, useState } from "react"

interface InlineJoinCTAProps {
  size?: 'small' | 'medium' | 'large'
}

const sizeConfig = {
  small: {
    container: 'px-4 py-3',
    gap: 'gap-3',
    icon: 'w-8 h-8',
    iconSize: '18',
    titleText: 'text-sm',
    subtitleText: 'text-xs',
    button: 'px-6 py-3 text-sm'
  },
  medium: {
    container: 'px-6 py-5',
    gap: 'gap-4',
    icon: 'w-12 h-12',
    iconSize: '24',
    titleText: 'text-base',
    subtitleText: 'text-sm',
    // Match hero CTA: rounded-xl, px-5 py-2.5, uppercase, tracking-wide
    button: 'px-8 py-4 text-sm sm:text-base'
  },
  large: {
    container: 'px-8 py-6',
    gap: 'gap-5',
    icon: 'w-16 h-16',
    iconSize: '32',
    titleText: 'text-lg',
    subtitleText: 'text-base',
    button: 'px-10 py-5 text-lg'
  }
}

export default function InlineJoinCTA({ size = 'medium' }: InlineJoinCTAProps) {
  const config = sizeConfig[size]
  const [shouldAnimate, setShouldAnimate] = useState(true)
  
  useEffect(() => {
    // Stop the animation after 3 seconds
    const timer = setTimeout(() => {
      setShouldAnimate(false)
    }, 3000)
    
    return () => clearTimeout(timer)
  }, [])
  
  return (
    <div className="mb-8">
      <Link
        href="/signup"
        className={`block w-full text-center rounded-xl bg-[#7294c7] text-white ${config.button} font-semibold uppercase tracking-wide shadow-lg hover:bg-[#5d7cb8] focus:outline-none focus:ring-2 focus:ring-[#5d7cb8]/30 transition-all duration-300 ${shouldAnimate ? 'animate-subtle-pulse' : ''}`}
      >
        Join as an Expert
      </Link>
    </div>
  )
}
